export const getDiffDays = (currentDate, modifiedDate) => {
  return currentDate.diff(modifiedDate, 'days')
}
